import * as FormMapActions from './form-map.actions';

import { Action, createReducer, on } from '@ngrx/store';

export const formMapFeatureKey = 'form-map';

export interface FormMapState {
	isInitialized: boolean;
	error?: any;
	isLoading?: boolean;
	latlng?: { latitude: number; longitude: number };
}

export interface FormMapPartialState {
	readonly [formMapFeatureKey]: FormMapState;
}

export const initialState: FormMapState = {
	isInitialized: false,
	// additional entity state properties
};

const formMapReducer = createReducer(
	initialState,
	on(FormMapActions.pinDropped, (state, { latlng }) => ({
		...state,
		latlng,
	})),
	on(FormMapActions.formMapSelected, (state, { coordinates }) => ({
		...state,
		latlng: { latitude: coordinates.lat, longitude: coordinates.lon },
	})),
	on(FormMapActions.formMapDestroyed, (state) => ({
		...state,
		error: undefined,
		isLoading: undefined,
		listMessage: undefined,
		subdivision: undefined,
		latlng: undefined,
		isInitialized: false,
	}))
);

export function reducer(state: FormMapState | undefined, action: Action) {
	return formMapReducer(state, action);
}
